export const SPOT_TV_CLEAR_STATE = 'SPOT_TV_CLEAR_STATE';

export const SPOT_TV_LEAVE_MEETING = 'SPOT_TV_LEAVE_MEETING';

export const SPOT_TV_SET_REMOTE_JOIN_CODE = 'SPOT_TV_SET_JOIN_CODE';

export const SPOT_TV_SET_STATE = 'SPOT_TV_SET_STATE';
